import { render, staticRenderFns } from "./PlaylistEditor.vue?vue&type=template&id=1b57bdc9&scoped=true&"
import script from "./PlaylistEditor.vue?vue&type=script&lang=js&"
export * from "./PlaylistEditor.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistEditor.vue?vue&type=style&index=0&id=1b57bdc9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b57bdc9",
  null
  
)

export default component.exports